export class AppliedManualDiscount {
  deductedUnitPriceAmount: number;
  discountedUnitPriceAfterDiscount: number;
  discountedUnitPriceBeforeDiscount: number;
  discountPercentage: number;
  discountType: AppliedManualDiscountTypeEnum;
  orderItemId: number;

  constructor(init?: AppliedManualDiscount) {
    Object.assign(this, init);
  }
}

export enum AppliedManualDiscountTypeEnum {
  commercial = 1,
  financial = 2
}
